module.exports = __webpack_public_path__ + "media/images/icon__warning-4702a44746063b4f729be5f712ffc362.png";